export default {
    app: {
        name:    'Imprion Admin',
        console: 'Admin Console',
    },
    general: {
        add:        'Add',
        edit:       'Edit',
        cancel:     'Cancel',
        save:       'Save',
        close:      'Close',
        confirm:    'Confirm',
        loading:    'Loading…',
        logout:     'Log out',
        theme:      'Toggle theme',
        retry:      'Retry',
        back:       'Back',
        view:       'View',
        actions:    'Actions',
        none:       'None',
        no_results: 'No results',
        reset:        'Reset',
        new_password: 'New password',
    },
    errors: {
        generic_error:      'An error occurred',
        invalid_data:       'Invalid data',
        not_found:          'Not found',
        unauthorized:       'Your session has expired. Please sign in again.',
        slug_taken:         'That slug is already taken.',
        invalid_transition: 'That action is not allowed in the client\'s current state.',
        tenant_not_active:  'The tenant is not active.',
        username_taken:     'That username or email is already in use.',
        on_add:             'Error while adding',
        on_edit:            'Error while updating',
    },
    success: {
        add:  'Successfully added',
        edit: 'Successfully updated',
    },
    auth: {
        sign_in:          'Sign in',
        sign_in_subtitle: 'Sign in to the Imprion Cashless admin console.',
        username:         'Username',
        password:         'Password',
        login_failed:     'Incorrect username or password.',
    },
    nav: {
        clients:      'Clients',
        client_users: 'Client users',
        support:      'Support',
        admin_users:  'Admin users',
        audit:        'Audit',
        open_menu:    'Open menu',
        account:      'Account',
    },
    client: {
        clients:             'Clients',
        subtitle:            'Provision and manage tenant clients.',
        add:                 'New client',
        create:              'Create client',
        edit:                'Edit',
        edit_name:           'Edit name',
        renamed_ok:          'Client renamed',
        slug:                'Slug',
        slug_hint:           'Lowercase letters, digits, and underscore (1–31 chars). This becomes the tenant database name and is immutable.',
        name:                'Name',
        status:              'Status',
        status_provisioning: 'Provisioning',
        status_active:       'Active',
        status_suspended:    'Suspended',
        status_archived:     'Archived',
        empty:               'No clients yet. Create one to provision a tenant.',
        detail:              'Client',
        suspend:             'Suspend',
        archive:             'Archive',
        confirm_suspend:     'Suspend this client? Its tenant is immediately gated out of the data plane.',
        confirm_archive:     'Archive this client? This is permanent — the tenant stays gated out and cannot be reactivated.',
        suspended_ok:        'Client suspended',
        archived_ok:         'Client archived',
        created:             'Created',
        provisioning_note:   'Provisioning runs in the background; this page refreshes the job status.',
    },
    provisioning: {
        title:   'Provisioning',
        status:  'Status',
        pending: 'Pending',
        running: 'Running',
        done:    'Done',
        failed:  'Failed',
    },
    support: {
        support:           'Support',
        subtitle:          'Audited entry into a tenant. Every block/unblock is recorded in the tenant and platform audit logs.',
        select_tenant:     'Tenant',
        pick_tenant_hint:  'Pick an active tenant to look up and act on its holders.',
        search_holder:     'Find a holder',
        search_placeholder:'Search by name, RFID, or UUID',
        no_holders:        'No holders match.',
        view:              'View',
        block:             'Block',
        unblock:           'Unblock',
        reason:            'Reason (optional)',
        reason_title:      'Support action',
        blocked_ok:        'Holder blocked',
        unblocked_ok:      'Holder unblocked',
        balances:          'Balances',
        no_balances:       'No balances.',
        ledger:            'Recent activity',
        no_ledger:         'No transactions.',
        date:              'Date',
        kind:              'Kind',
        value_type:        'Value type',
        amount:            'Amount',
        external_id:       'External ID',
        kind_funding:      'Funding',
        kind_spend:        'Spend',
        kind_reversal:     'Reversal',
        kind_adjustment:   'Adjustment',
        kind_transfer:     'Transfer',
    },
    admin_user: {
        admin_users:   'Admin users',
        subtitle:      'Imprion staff who can operate the admin console.',
        add:           'Add admin',
        create:        'Create admin user',
        edit:          'Edit',
        edit_user:     'Edit admin user',
        name:          'Name',
        username:      'Username',
        email:         'Email',
        password:      'Password',
        password_hint: 'At least 8 characters.',
        empty:         'No admin users yet.',
        created:       'Created',
        reset_password:'Reset password',
        reset:         'Reset',
        reset_ok:      'Password reset',
    },
    client_user: {
        client_users:  'Client users',
        subtitle:      'Tenant-portal login identities and their client assignments.',
        add:           'New user',
        create:        'Create client user',
        edit:          'Edit',
        edit_user:     'Edit user',
        detail:        'User',
        name:          'Name',
        username:      'Username',
        email:         'Email',
        password:      'Password',
        password_hint: 'At least 8 characters.',
        empty:         'No client users yet.',
        created:       'Created',
        reset_password:'Reset password',
        reset:         'Reset',
        reset_ok:      'Password reset',
        assignments:   'Client assignments',
        no_assignments:'Not assigned to any client.',
        assign:        'Assign to client',
        assign_title:  'Assign to a client',
        select_client: 'Client',
        select_role:   'Role',
        role_admin:    'Admin — full access',
        role_viewer:   'Viewer — read-only',
        assigned_ok:   'User assigned',
        status_active: 'Active',
        status_disabled: 'Disabled',
        remove:        'Remove',
        confirm_remove:'Remove this user from {client}? They will lose access to it. You can re-assign them later.',
        removed_ok:    'User removed from client',
    },
    audit: {
        audit:    'Audit',
        subtitle: 'The platform-level record of admin actions, newest first.',
        actor:    'Actor',
        action:   'Action',
        target:   'Target',
        detail:   'Detail',
        time:     'Time',
        empty:    'No audit entries yet.',
        system:   'system',
    },
    holder: {
        status_active:  'Active',
        status_blocked: 'Blocked',
        anonymous:      'Anonymous',
    },
}
